$('body').on('click', '.quick-add-bulk-popup-wrapper', function(e) {
    e.preventDefault();
    var cstm_url = $(this).attr('data-product-link');

    if (!cstm_url) {
        console.error('Custom URL is missing or invalid.');
        return;
    }
    $('.featured-collection-loader-wrapper').css('display', 'flex');
    $('body').addClass('quick-view-active');
$('.featured-collection-data-popup-wrapper svg.icon.icon-close').hide();
$.ajax({
    url: cstm_url,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
        var productHtml = $(data).find('.product-main-wrapper');

        if (productHtml.length) {
            var productInfo = productHtml.find('product-info');
             $('.featured-collection-data-popup-wrapper').css('display', 'block');
         $('.featured-collection-data-popup').html(productHtml.html());

            $('.featured-collection-loader-wrapper').css('display', 'none');
           setTimeout(function () {
          $('.featured-collection-data-popup-wrapper svg.icon.icon-close').show();
              }, 1000);
        } else {
            console.error('Product main wrapper not found in the response.');
        }
    },
    error: function(jqXHR, textStatus, errorThrown) {
        console.error('AJAX error:', textStatus, errorThrown);
    }
});
  



});

document.body.addEventListener('click', function (event) {
    if (event.target.closest('.featured-collection-data-popup-wrapper svg.icon.icon-close')) {
  setTimeout(function() {
    document.body.classList.remove('quick-view-active');
     document.querySelector('.featured-collection-data-popup-wrapper').style.display = 'none';
   
}, 1000);
       
        
    }
});

document.addEventListener("click", function (event) {
    let popupWrapper = document.querySelector(".featured-collection-data-popup-wrapper");
    if (!popupWrapper || window.getComputedStyle(popupWrapper).display === "none") {
        return; 
    }

    
    if (!popupWrapper.contains(event.target)) {
        document.body.classList.remove("quick-view-active");
        popupWrapper.style.display = "none";
    
    } else {
       
    }
});